var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "c-modal",
    {
      attrs: {
        toggle: _vm.confirm_modal.toggle,
        status: _vm.confirm_modal.store.status,
        content_width: _vm.$screen.mobile ? "80%" : "30%",
      },
    },
    [
      _c(
        "c-interactive-panel",
        {
          attrs: { title: _vm.title, has_close_button: "" },
          on: {
            close_button_click: function () {
              return _vm.confirm_modal.toggle()
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "confirm-modal__footer" },
                    [
                      _c(
                        "p-custom-button",
                        {
                          attrs: { type: "border" },
                          on: { click: _vm.on_cancel },
                        },
                        [_vm._v("取消")]
                      ),
                      _c("p-custom-button", { on: { click: _vm.on_confirm } }, [
                        _vm._v("确认"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "p",
            { staticClass: "confirm-modal__content" },
            [_vm._t("default")],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }